import { configureStore } from '@reduxjs/toolkit'

import users from './slices/users'

const store = configureStore({
  reducer: {
    [users.name]: users.reducer,
  },
})

export default store
